// Minimal model for store API interactions.
// Centralizes fetching logic so the UI doesn't call fetch directly.

import { fetchStore } from '../services/storeService';
import { mockStore, getMockStore } from '../mocks/mockStore';
import { getFinalMockStore } from '../services/storeCreationService';

export async function getStore() {
  // Try API first
  try {
    const res = await fetchStore();
    if (res && res.status === 200) {
      return await res.json();
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('API store fetch failed', err);
  }
  // Fallback sequence: final assembled mock -> dynamic final -> static fallback
  const finalLocal = getFinalMockStore();
  if (finalLocal) return finalLocal;
  const dynamicMock = getMockStore();
  if (dynamicMock) return dynamicMock;
  return mockStore;
}

export { mockStore, getMockStore };
